import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.GROUP_EDIT_SUCCESS, group: data.group });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.GROUP_EDIT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const groupEdit = (data, groupId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.GROUP_EDIT_REQUEST });

    axios.put(`/groups/${groupId}`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
